import React from 'react';

import { Input, Select } from 'design-system';

import AmountFilterField from './AmountFilterField';
import { FiltersBarContainer, Grid } from './styles';

const SearchIcon = (): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M7.25 12.5C10.1495 12.5 12.5 10.1495 12.5 7.25C12.5 4.35051 10.1495 2 7.25 2C4.35051 2 2 4.35051 2 7.25C2 10.1495 4.35051 12.5 7.25 12.5Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 14L11.1 11.1"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export type FiltersBarProps = {
  invoiceNumberValue?: string;
  emissionMonthValue?: string;
  amountValue?: string;
  emissionMonthOptions?: Array<{ value: string; label: string }>;
  onInvoiceNumberChange?: (value: string) => void;
  onEmissionMonthChange?: (value: string) => void;
  onAmountChange?: (value: string) => void;
  onAmountFocus?: () => void;
  onAmountBlur?: () => void;
  className?: string;
};

const FiltersBar = ({
  invoiceNumberValue = '',
  emissionMonthValue = '',
  amountValue = '',
  emissionMonthOptions = [],
  onInvoiceNumberChange,
  onEmissionMonthChange,
  onAmountChange,
  onAmountFocus,
  onAmountBlur,
  className,
}: FiltersBarProps): JSX.Element => (
  <FiltersBarContainer className={className}>
    <Grid>
      <Input
        label="Número da nota"
        placeholder="buscar..."
        shape="pill"
        fullWidth
        trailingIcon={<SearchIcon />}
        value={invoiceNumberValue}
        onChange={(event) => onInvoiceNumberChange?.(event.target.value)}
      />

      <Select
        label="Data de emissão"
        shape="pill"
        fullWidth
        value={emissionMonthValue}
        onChange={(event) => onEmissionMonthChange?.(event.target.value)}
      >
        <option value="">Selecione</option>
        {emissionMonthOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>

      <AmountFilterField
        value={amountValue}
        onChange={(value) => onAmountChange?.(value)}
        onFocus={onAmountFocus}
        onBlur={onAmountBlur}
      />
    </Grid>
  </FiltersBarContainer>
);

export default FiltersBar;
